import Popper from '@zenbusiness/zui/Popper';
import { styled } from '@zenbusiness/zui/styles';

const PopperStyle = ({ theme }) => ({
  boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
  borderRadius: '16px',
  '& .MuiAutocomplete-noOptions': {
    color: `${theme.palette.text.secondary} !important`
  }
});

export const StyledPopper = styled(Popper)(PopperStyle);
